import { Layout, TextLink } from '@oneaudi/unified-web-components';

import styled from 'styled-components';

export const StyledTextLinkButton = styled(TextLink)`
	justify-self: start;
	align-self: flex-start;
`;

export const StyledDialogContent = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const StyledFullLayout = styled(Layout)`
	width: 100%;
	height: 100%;

	iframe {
		height: 100%;
		width: 100%;
		min-height: 80dvh;
	}
`;
